<template>
  <Visualization :isTestPortal="true" />
</template>
<script>
import Visualization from "./index.vue";

export default {
  name: "test-portal-study-participanta",
  components: {
    Visualization
  }
};
</script>
